import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { Input } from "components/Form";
import { Button } from "components/Button/Button";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import ModalBox from "components/modal/ModalBox";
import Switch from "components/Switch/Switch";
import TextEditor from "components/TextEditor/TextEditor"; // ✅ your editor

import { cityWiseSectionCreate } from "services/citypages"; // 🔹 you’ll need to add this API if not already present
import { ContentState, EditorState } from "draft-js";
import { rawToHtmlConverter, wrapImagesWithFigure } from "utils";

const AddCityWiseSection = ({ open, onClose, cityId, citywisecenterListing }) => {
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();

  const [formData, setFormData] = useState({
    section: "",
    description: "",
    ish1tag: 0,
  });

  const [errorField, setErrorField] = useState({
    section: "",
    description: "",
  });

  // ********* Validation *********
  const handleValidation = () => {
    let errors = {};
    let valid = true;

    if (!formData.section) {
      errors["section"] = "Please enter heading";
      valid = false;
    }
    if (!formData.description) {
      errors["description"] = "Please enter description";
      valid = false;
    }

    setErrorField(errors);
    return valid;
  };

  // ********* Submit *********
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("formdata", formData);
    
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        const payload = {
          cityid: cityId,
          section: formData.section,
          description: formData.description,
          description: rawToHtmlConverter(formData.description.getCurrentContent()),
            
          ish1tag: formData.ish1tag ? 1 : 0,
        };

        const res = await cityWiseSectionCreate(payload); // 🔹 API call
        if (res.code === 200) {
          toast.success(res.message || "Section added successfully");
          citywisecenterListing();
          modalOnClose();
        } else {
          toast.error(res.message);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      } finally {
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  // ********* Change Handler *********
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ********* Close / Reset *********
  const modalOnClose = () => {
    setFormData({
      section: "",
      description: "",
      ish1tag: 0,
    });
    setErrorField({});
    onClose();
  };

  return (
    <ModalBox
      status={open}
      onClose={modalOnClose}
      size="md"
      title={"Add New Section"}
      customizedFooter={
        <div>
          <Button onClick={handleSubmit} {...submitButtonElement}>
            Add Section
          </Button>
        </div>
      }
    >
      <div className="form-group row mt-1">
        <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
          <div className="row">
            {/* Heading */}
            <div className="col-sm-12 col-form-label">
              <Input
                type="text"
                name="section"
                value={formData.section}
                onChange={onChangeHandler}
                placeholder="Enter Section Heading"
                className="form-control"
                label={"Heading"}
                error={errorField.section}
                required
                {...submitButtonElement}
              />
            </div>

            {/* Description */}
            <div className="col-sm-12 col-form-label mt-2">
              <label className="form-label">Description</label>
              <TextEditor
                value={formData.description}
                onChange={(val) =>
                  setFormData({ ...formData, description: val })
                }
              />
              {errorField.description && (
                <span className="text-danger small">
                  {errorField.description}
                </span>
              )}
            </div>

            {/* H1 Tag Toggle */}
            <div className="col-sm-12 col-form-label mt-3 d-flex align-items-center">
              <Switch
                checked={formData.ish1tag === 1}
                onChange={() =>
                  setFormData({ ...formData, ish1tag: formData.ish1tag ? 0 : 1 })
                }
              />
              <span className="ms-2">Mark as H1 Tag</span>
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
};

export default AddCityWiseSection;
